import { render } from "./TableApi.vue?vue&type=template&id=1ff2585c&scoped=true"
import script from "./TableApi.vue?vue&type=script&lang=js"
export * from "./TableApi.vue?vue&type=script&lang=js"

import "./TableApi.vue?vue&type=style&index=0&id=1ff2585c&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff2585c"]])

export default __exports__